import type { FC } from 'react';

import type { OfficeId } from 'src/tv/live/places';

/**
 * One line icon per office, drawn here on a 24×24 grid (not the cities' own logos, which are protected): three
 * crowns for Stockholm, the cathedral's two spires for Uppsala, the opera's sloping roof for Oslo. Stroke in
 * `currentColor`, so they take the text colour around them.
 */
const GLYPHS: Record<OfficeId, string> = {
  stockholm: 'M2 10V5l2 2 2-3 2 3 2-2v5zM14 10V5l2 2 2-3 2 3 2-2v5zM8 20v-5l2 2 2-3 2 3 2-2v5z',
  uppsala: 'M3 21h18M5 21V10l2-8 2 8v11M15 21V10l2-8 2 8v11M9 14h6M9 21v-7M15 21v-7M12 17.5a1.5 1.5 0 1 0 0-.01',
  oslo: 'M2 19l11-7h8v7M14 12V7h5v5M2 19h20M4 22h5M12 22h6',
};

/** The icon's paths, for use inside an `<svg>` (the map draws it there at its own size). */
export const CityGlyph: FC<{ office: OfficeId }> = (props) => {
  const { office } = props;

  return (
    <path
      d={GLYPHS[office]}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );
};

interface CityIconProps {
  office: OfficeId;
  size: string;
}

const CityIcon: FC<CityIconProps> = (props) => {
  const { office, size } = props;

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden
      style={{ flexShrink: 0 }}
    >
      <CityGlyph office={office} />
    </svg>
  );
};

export default CityIcon;
